<template>
	<type-wrapper class="type-F" padding>
		<type-grid row="1" margin v-if="showData.title">
			<type-title large>{{ showData.title }}</type-title>
		</type-grid>
		<type-grid row="1" margin center v-if="pictureList.length">
			<div class="type-F-logo" v-for="(item, index) in pictureList" :key="index">
				<type-image mode="heightFix" :src="item" :alt="showData.alt"></type-image>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 横幅一排图片
	import mixin from '../mixin.js'
	export default {
		name: 'type-F',
		mixins: [ mixin ],
		computed: {
			pictureList() {
				return this.showData.picture || [];
			}
		}
	}
</script>

<style scoped lang="less">
	.type-F-logo{
		display: inline-flex;
		height: 50px;
		margin: 10px;
	}
</style>
